<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header">
        <i class="fa fa-list mr-2"></i>
        <strong>Import fichier stock DB/CO</strong>
        <div class="card-header-actions">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
            <span class="when-opened"><i class="icon-arrow-down"></i></span>
            <span class="when-closed"><i class="icon-arrow-up"></i></span>
          </b-link>
        </div>
      </div>
      <b-collapse id="collapse2" visible>
        <b-card-body>
          <b-row>
            <b-col md="2" class="mt-2">
              <span>Chargement fichier stock DBCO : </span>
            </b-col>
            <b-col md="5">
              <b-form-group label-for='nom_fichier'>
                <b-form-file placeholder="Joindre un fichier"
                             class="file-input"
                             drop-placeholder="Déposer le fichier ici..."
                             browse-text="Parcourir"
                             :state="errors.attachment !== '' ? false : null"
                             @change="addFile($event)">
                </b-form-file>
                <span class="field-error">{{ errors.attachment }}</span>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-button type="enter" @click.prevent="importFile" size="md" variant="primary">
                <i class="fa fa-upload"></i> Importer
              </b-button>
            </b-col>
          </b-row>
          <v-client-table v-if="dataIsReady" class="mt-4" :columns="columns" :data="items" :options="options">
            <div v-if="props.row.siren" slot="siren" slot-scope="props" class="slot-date">
              {{ props.row.siren }}
            </div>
            <div v-if="props.row.date_reception" slot="date_reception" slot-scope="props" class="slot-date">
              <span class="badge badge-success p-2">{{ dateFormat(props.row.date_reception) }}</span>
            </div>
            <div v-if="props.row.type_document" slot="type_document" slot-scope="props">
              {{ props.row.type_document }}
            </div>
            <div v-if="props.row.date_naissance" slot="date_naissance" slot-scope="props" class="slot-date">
              {{ dateFormat(props.row.date_naissance) }}
            </div>
            <div v-if="props.row.date_traitement" slot="date_traitement" slot-scope="props" class="slot-date">
              <span class="badge badge-success p-2">{{ dateFormat(props.row.date_traitement) }}</span>
            </div>
            <div slot="db_clause" slot-scope="props">
              {{ props.row.db_clause !== 'null' ? props.row.db_clause : '-' }}
            </div>
            <div slot="co_option" slot-scope="props">
              {{ props.row.co_option !== 0 ? props.row.co_option : '-' }}
            </div>
          </v-client-table>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {hasRule, espaceGestionRules} from "@/utils/rulesHelper";
  import {formatDate} from "@/utils/communHelper";
  import moment from 'moment';

  export default {
    name: "Chargement-Stock-DBCO",
    data() {
      return {
        rules: espaceGestionRules,
        dataIsReady: false,
        attachment: null,
        errors: {
          attachment: '',
        },
        columns: ['siren', 'type_document', 'support', 'email', 'nom_naissance', 'nom_usage', 'prenom', 'date_naissance', 'date_reception', 'date_traitement', 'is_conforme', 'db_clause', 'co_option'],
        items: [],
        options: {
          headings: {
            siren: 'SIREN',
            type_document: 'Type',
            support: 'Support',
            email: 'Email',
            nom_naissance: 'Nom naissance',
            nom_usage: 'Nom usage',
            prenom: 'prenom',
            date_naissance: 'Date naiss.',
            date_reception: 'Date récep.',
            date_traitement: 'Date trait.',
            is_conforme: 'Conforme',
            db_clause: 'Clause DB',
            co_option: 'CO',
          },
          perPage: 10,
          filterable: false,
          sortable: ['date_reception', 'nom_naissance', 'nom_usage', 'siren'],
          perPageValues: [10, 25, 50],
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.all();
    },
    methods: {
      addFile(event) {
        this.attachment = event.target.files[0];
      },
      importFile() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let formData = new FormData();
          formData.append('file', this.attachment);
          this.$axios
            .post(`/espaceGestion/referentiel_dbco_recu/import_excel`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then((response) => {
              this.$store.commit("IS_LOADING", false);
              this.all();
              let imported = response.data.nbImported;
              let total = response.data.nbTotal;
              let html = 'L\'import s\'est terminé avec succès<br>' + imported + ' nouvelles lignes importées sur un total de ' + total + ' lignes.'
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Ajout avec succès',
                html: html,
                // text: "L'import s'est terminé avec succès",
                showConfirmButton: false,
                timer: 0
              });
            })
            .catch(() => {
              this.handleErrors();

            });
        }
      },
      all() {
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/espaceGestion/referentiel_dbco_recu/all")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.items = response.data.dbco;
            this.dataIsReady = true;
          })
          .catch(() => {
            this.handleErrors();
          });
      },
      dateFormat(textDate) {
        return formatDate(textDate);
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.attachment === null) {
          this.errors.attachment = "Veuillez choisir un fichier";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.attachment = "";
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Une erreur système est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 4000,
        });
      },
    }
  }
</script>
